export type ZippyEnvironment = 'production' | 'staging' | 'development';

/** API origin per environment. Paths such as `/api/v1/...` are appended by the SDK client. */
export const ZIPPY_API_BASE_URLS: Record<ZippyEnvironment, string> = {
  production: 'https://api.zippypay.io',
  staging: 'https://staging.api.zippypay.io',
  /** Same-origin — local demo proxies `/api/*` to the backend (avoids CORS). */
  development: '',
};

export const ZIPPY_API_PATH_PREFIX = '/api/v1';

export function isZippyEnvironment(value: string): value is ZippyEnvironment {
  return value in ZIPPY_API_BASE_URLS;
}

export function resolveApiBaseUrl(environment: ZippyEnvironment): string {
  return ZIPPY_API_BASE_URLS[environment].replace(/\/+$/, '');
}

export function parseZippyEnvironment(value: string): ZippyEnvironment {
  const normalized = value.trim().toLowerCase();
  if (!isZippyEnvironment(normalized)) {
    throw new Error(
      `Zippy Pay: invalid environment "${value}". Expected one of: ${Object.keys(ZIPPY_API_BASE_URLS).join(', ')}.`,
    );
  }
  return normalized;
}
